import { render, staticRenderFns } from "./zykjfw.vue?vue&type=template&id=9f5fa92a&scoped=true&"
import script from "./zykjfw.vue?vue&type=script&lang=js&"
export * from "./zykjfw.vue?vue&type=script&lang=js&"
import style0 from "./zykjfw.vue?vue&type=style&index=0&id=9f5fa92a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f5fa92a",
  null
  
)

export default component.exports